export type CmtsDashboardScopePanelProps = {
  readonly scope?: Record<string, unknown> | null | undefined;
  readonly readOnly?: boolean | undefined;
};

export function CmtsDashboardScopePanel(props: CmtsDashboardScopePanelProps) {
  const entries = Object.entries(props.scope ?? {}).filter(
    ([, value]) => value !== undefined && value !== null && String(value).trim(),
  );

  return (
    <aside className="cmts-dashboard-scope-panel" aria-label="Dashboard permission scope">
      <div className="flex items-center gap-2">
        <div className="flex h-6 w-6 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
          <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
        </div>
        <strong>{props.readOnly ? "Read-only scope" : "Backend permission scope"}</strong>
      </div>
      {entries.length ? (
        <dl>
          {entries.map(([key, value]) => (
            <div key={key}>
              <dt>{key}</dt>
              <dd>{String(value)}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <p>Scope is enforced by backend response and current session.</p>
      )}
    </aside>
  );
}

